module.exports = __webpack_public_path__ + "static/media/elements-app-responsive.1fca6b09.svg";